import React, { useState } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  Box,
} from '@mui/material';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import ManualMassCreate from './ManualMassCreate';

const MassCreateCredentialsPage = () => {
  const { isLoggedIn, user } = useAuth();
  const { t } = useTranslation();

  // future-proof: add more modes without changing layout logic
  const [mode, setMode] = useState('manual'); // 'manual' | 'dll'

  const handleModeChange = (_event, newMode) => {
    // ToggleButtonGroup sends null when user clicks the already selected option
    if (newMode) setMode(newMode);
  };

  if (!isLoggedIn) return <CircularProgress />;

  return (
    <>
      <Sidebar user={user} />
      <Container maxWidth="xl">
        <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4" gutterBottom>
                {t('massCreateCredentials.title', 'Mass create credentials')}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="subtitle1">
                  {t('massCreateCredentials.mode', 'Mode')}
                </Typography>

                <ToggleButtonGroup
                  value={mode}
                  exclusive
                  onChange={handleModeChange}
                  size="small"
                >
                  <ToggleButton value="manual">
                    {t('massCreateCredentials.modes.manual', 'Manual')}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>

            <Grid item xs={12}>
              {<ManualMassCreate />}
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default MassCreateCredentialsPage;
